module.exports = __webpack_public_path__ + "img/pages.a08dcb44.svg";